import {Manufacturer} from "./Manufacturer";
import {Catalog} from "./Catalog";

export enum PromoType {
  COST = 'COST',
  PERCENT = 'PERCENT'
}

export interface PromoCode {
  id?: number;
  manufacturerId?: number;
  manufacturer?: Manufacturer;
  catalogId?: number;
  catalog?: Catalog;
  header: string;
  code: string;
  dateStart?: Date|string;
  dateEnd?: Date|string;
  promoType: PromoType;
  discount: number;
  createdAt: Date;
  enabled: boolean;
  deleted?: boolean;
  updatedAt?: Date;
}
